export const TUTORIAL_PROGRESS_VERSION = 1;
export const UI_TOUR_VERSION = 1;

/**
 * When `false`, onboarding help (UI tour, core checklist, contextual tips) does not
 * open automatically on login or route changes. Users can still open help from Help.
 * Set back to `true` after onboarding content is finalized for production rollout.
 * @type {boolean}
 */
export const AUTO_OPEN_ONBOARDING_HELP = false;

export const ADMIN_TUTORIAL_AUTHORITIES = ["owner", "admin", "superAdmin"];

export const TUTORIAL_ROUTES = {
  coreUsers: ["/users", "/settings/users", "/employees"],
  coreClients: ["/clients"],
  coreJobs: ["/jobs"],
  invoices: ["/invoices"],
  manifests: ["/manifests"],
  payouts: ["/payouts"],
};

export const MODULE_FEATURE_KEYS = {
  invoices: "invoices.enabled",
  manifests: "manifests.enabled",
  payouts: "payouts.enabled",
};

export const DEFAULT_TUTORIAL_PROGRESS = {
  version: TUTORIAL_PROGRESS_VERSION,
  uiTourVersion: UI_TOUR_VERSION,
  uiTourCompleted: false,
  coreAdminOnboardingCompleted: false,
  coreSteps: {
    users: false,
    clients: false,
    jobs: false,
  },
  contextual: {
    invoices: false,
    manifests: false,
    payouts: false,
  },
  completedAt: null,
  updatedAt: null,
};
